import React, { useEffect, useRef, useState } from 'react';
import Message from 'src/javascripts/components/widget/Message';
import WidgetCanvas from 'src/javascripts/components/widget/WidgetCanvas';
import t from 'src/javascripts/services/translations';
import WidgetMessageService from 'src/javascripts/services/widget-message-service';
import { Shop } from 'src/javascripts/shared/chat';

interface Props {
  messageService: WidgetMessageService;
  cityMessengerLogo: string;
  shops: Shop[];
  renderCanvas: boolean;
  transparentBackground: boolean;
}

export default ({ messageService, shops, cityMessengerLogo, renderCanvas, transparentBackground }: Props) => {
  const [messages, setMessages] = useState(messageService.messages);
  const [chatClassNames, setChatClassNames] = useState('');
  let hasScrolled = false;

  const scrollWrapper = useRef(null);

  function scroll() {
    const $scrollWrapper = $(scrollWrapper.current);
    const atBottom = $scrollWrapper.scrollTop() + $scrollWrapper.height() >= $scrollWrapper.children().height();
    /* istanbul ignore next */
    if (atBottom && !hasScrolled) {
      messageService.loadOlderMessages();
      hasScrolled = true;
    }
  }

  useEffect(() => {
    messageService.subscribe(setMessages);
    scroll();
    return () => messageService.unsubscribe();
  });

  return (
    <div className={transparentBackground ? 'widget bg-transparent' : 'widget'} onScroll={scroll} onWheel={scroll}>
      <a id="cm-link" href="/" target="_blank" className={renderCanvas ? 'header' : 'header border-bottom'}>
        <img src={cityMessengerLogo} alt="City Messenger Logo" className="cm-logo"/>
        <p className="cm-intro">{t('broadcast.widget.intro')}</p>
      </a>
      <div className="scroll-wrapper hide-scrollbar" ref={scrollWrapper}>
        <div className={'chat ' + chatClassNames}>
          {!messages.length && <p className="alert alert-info">{t('broadcast.widget.no_messages')}</p>}
          {messages.map(message => <Message message={message} shop={shops.find(shop => message.sender.id === shop.id)} key={message.id}/>)}
        </div>
      </div>
      {renderCanvas && <WidgetCanvas setChatClassNames={setChatClassNames} />}
    </div>
  );
};
